import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export function EmptyListLarge(props: IconProps): JSX.Element {
  const { ...rest } = props;

  return (
    <SvgIcon
      {...rest}
      enclosed
      name="EmptyListLarge"
      size="l"
      viewBox="0 0 48 48"
    >
      <path
        d="M34.3 5 39 9.7V43H9V5h25.3Zm1.2-3H6v44h36V8.5L35.5 2Z"
        fill="currentColor"
      />
      <path
        d="M16 23a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM32 23a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM28.5 30h-9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
